import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Logo } from "../../components/app/Logo";
import { Button } from "../../components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { useCurrentCompany, useCurrentUser, useSession } from "../../services/SessionContext";

export function CompanySetupPage() {
  const user = useCurrentUser();
  const company = useCurrentCompany();
  const { createCompany } = useSession();
  const [companyName, setCompanyName] = useState("");
  const [userName, setUserName] = useState(user?.name ?? "");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  if (company) return <Navigate to="/app/dashboard" replace />;

  function submit(event: React.FormEvent) {
    event.preventDefault();
    setError("");
    try {
      createCompany(companyName, userName);
      navigate("/app/dashboard");
    } catch (err) {
      setError(err instanceof Error ? err.message : "Company setup failed.");
    }
  }

  return (
    <div className="grid min-h-screen bg-slate-50 px-4 py-8">
      <div className="mx-auto w-full max-w-xl self-center">
        <div className="mb-8 flex justify-center">
          <Logo />
        </div>
        <Card className="shadow-panel">
          <CardHeader>
            <CardTitle>Create your company workspace</CardTitle>
          </CardHeader>
          <CardContent>
            <form className="space-y-4" onSubmit={submit}>
              <div className="space-y-2">
                <Label htmlFor="company-name">Company name</Label>
                <Input
                  id="company-name"
                  required
                  value={companyName}
                  onChange={(event) => setCompanyName(event.target.value)}
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="user-name">Your name</Label>
                <Input
                  id="user-name"
                  value={userName}
                  onChange={(event) => setUserName(event.target.value)}
                />
              </div>
              {error ? <p className="text-sm font-medium text-red-700">{error}</p> : null}
              <Button type="submit">Create workspace</Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
